import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Document } from '../../../models/document.model';

@Component({
  template: ''
})
export abstract class DocumentCaptureBase {
  @Input() progress: number = 0;
  @Input() document!: Document;

  @Output() onChanged = new EventEmitter();
  @Output() onSubmitted = new EventEmitter();
  @Output() onErrorMessageClosed = new EventEmitter();

  onSubmit() {
    this.onSubmitted.emit(this.document);
  }

  closeErrorMessage() {
    this.onErrorMessageClosed.emit(this.document);
  }
}
